import { createListenerMiddleware } from '@reduxjs/toolkit';

import { dismissAlertToasts } from '../hooks/useToaster/dismissAllToasts.ts';
import {
  setReferenceViewOpen,
  setSelectedDataSheet,
} from './features/referenceBarUISlice.ts';
import {
  setFocusedOrderDetailsFieldKey,
  setFocusedPropertyGridCellKey,
} from './features/uiSlice.ts';
import { RootState } from './types.ts';

export const dismissCraftsmanAlertsToastsMiddleware = createListenerMiddleware();

dismissCraftsmanAlertsToastsMiddleware.startListening({
  actionCreator: setReferenceViewOpen,
  effect: (action, listenerApi) => {
    if (action.payload) return;
    listenerApi.dispatch(setFocusedPropertyGridCellKey(undefined));
    listenerApi.dispatch(setFocusedOrderDetailsFieldKey(undefined));
    const prev = listenerApi.getOriginalState() as RootState;
    if (prev.referenceBarUI.selectedDataSheet !== 'craftsman-alerts') return;
    dismissAlertToasts();
  },
});

dismissCraftsmanAlertsToastsMiddleware.startListening({
  actionCreator: setSelectedDataSheet,
  effect: (action, listenerApi) => {
    if (action.payload === 'craftsman-alerts') return;
    const prev = listenerApi.getOriginalState() as RootState;
    if (prev.referenceBarUI.selectedDataSheet !== 'craftsman-alerts') return;
    if (!prev.referenceBarUI.referenceViewOpen) return;
    if (prev.referenceBarUI.alertsPanelAutoOpenedForNavBlock) return;
    dismissAlertToasts();
  },
});
